module.exports = __webpack_public_path__ + "static/media/go-create-background-image.639e9303.png";